// This hash method must be identical to the hash method in platform-frontend-gateway
export async function generateHash(message) {
  if (!message) {
    throw new Error('Please use a meaningful message for hashing');
  }
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = [...new Uint8Array(hashBuffer)];
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}